/**
 * This class allows for easier calling of functions that need to be re-run after the DOM has been modified.
 *
 * (replacing HTML breaks DOM, so you have to re-run scripts that register handlers again)
 */

FunctionsCaller = {
    callables: [],
    groups: {},
    alreadyCalled: [],
    uniqueIds: [],
    isRunningAll: false,

    /**
     * Registers the function and runs it when the document is ready.
     *
     * @param callable
     * @param {string | string[]}[groupIds] Identifiers of groups of callables this callable should be assigned to.
     */
    register: function (callable, groupIds) {
        this.private.addToCallables(callable, groupIds);

        switch (document.readyState) {
            case "loading":
                jQuery(document).ready(callable);
                break;
            case "interactive":
                callable(jQuery);
                break;
            case "complete":
                callable(jQuery);
                break;
        }

        return true;
    },

    /**
     * Registers the function and ensures that it is only registered once if multiple registration attempts were made.
     *
     * @param id
     * @param callable
     * @param {string | string[]}[groupIds]
     */
    registerUnique: function(id, callable, groupIds) {
        if(id in this.uniqueIds) {
            return false;
        }

        this.uniqueIds[id] = callable;

        return this.register(callable, groupIds);
    },

    /**
     * Registers the function and runs it immediately.
     *
     * @param callable
     * @param {string | string[]}[groupIds]
     */
    registerAndRunImmediately: function (callable, groupIds) {
        this.private.addToCallables(callable, groupIds);
        this.runImmediately(callable);

        return true;
    },

    runImmediately: function(callable) {
        callable(jQuery);
    },

    /**
     * Runs all registered functions again.
     *
     * This function should be called after an AJAX call that modifies parts of page with registered DOM listeners.
     *
     * This function should not be called right after a document load (jQuery(document).ready() handles calling of
     * individual registered functions that should be called)
     */
    runAll: function () {
        // If we are already running all, we ignore more calls to this method.
        if (this.isRunningAll) {
            return;
        }
        this.isRunningAll = true;
        for (var index = 0; index < this.callables.length; index++) {
            this.callables[index](jQuery);
        }
        this.isRunningAll = false;
    },

    runGroup: function(groupId) {
        if( -1 !== this.private.runningGroupIds.indexOf(groupId)) {
            // The group is already running, do not start it again.
            console.log("Already running group " + groupId + " was called to be started again.");
            return;
        }

        var index = this.private.runningGroupIds.push(groupId) - 1;

        _.each(this.groups[groupId], function(callable, key) {
            callable(jQuery);
        });

        // We store the information about this group being run.
        this.private.runningGroupIds[index] = groupId + "-done";
    },

    /**
     * Private internal methods.
     *
     * Should be refactored to be truly private when this object is refactored to namespaced one.
     */
    private: {
        /**
         * The ids of groups that are currently running. Similar to isRunningAll.
         */
        runningGroupIds: [],

        /**
         * @param callable
         * @param {string | string[]}[groupIds]
         */
        addToCallables: function(callable, groupIds) {
            FunctionsCaller.callables.push(callable);

            if (typeof groupIds !== 'undefined') {
                if( typeof groupIds === 'string' ) {
                    groupIds = [ groupIds ];
                }

                _.each(groupIds, function(groupId, key) {
                    if (typeof FunctionsCaller.groups[groupId] === 'undefined') {
                        FunctionsCaller.groups[groupId] = [];
                    }
                    
                    FunctionsCaller.groups[groupId].push(callable);
                });
            }
        }
    }
};
